import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { DmsHttp } from '../../../core/classes/dms-http';
import { MenuBurguerIconsFavorites } from '../../../core/constans/menu-burger-icons-favorites';
import { SidenavRoutes } from '../../../core/constans/side-nav.routes';
import { Child } from '../../../core/interfaces/child.interface';

@Injectable()
export class MarcadorFavoritoService extends DmsHttp {


    private _favorites: any[];
    url_add_Favorite = `${environment.SessionService.URL}${environment.SessionService.ENDPOINT.add_Favorite}`;
    url_delete_Favorite = `${environment.SessionService.URL}${environment.SessionService.ENDPOINT.delete_Favorite}`;

    constructor(_http: HttpClient) {
        super(_http, null);
    }

    addFavorite(): Observable<any> {
        const optionMenu = JSON.parse(sessionStorage.getItem('optionMenu'));
        return this.newPost(this.url_add_Favorite, { 'optionId': optionMenu.ID }).pipe(map((result: any) => {
            this.setFavorites(result !== null ? result : []);
        }));
    }

    deleteFavorite(): Observable<any> {
        const optionMenu = JSON.parse(sessionStorage.getItem('optionMenu'));
        return this.newPost(this.url_delete_Favorite, { 'optionId': optionMenu.ID }).pipe(map((result: any) => {
            this.setFavorites(result !== null ? result : []);
        }));
    }

    setFavorites(favorites: Child[]) {
        this._favorites = favorites.map(x => {
            x.Icon = MenuBurguerIconsFavorites[x.Name];
            x.route = SidenavRoutes[x.ID];
            return x;
        });
        sessionStorage.setItem('userFavorites', JSON.stringify(favorites));
    }

    get favorites() {
        return this._favorites;
    }

    isThisFavorite(): boolean {
        const optionMenu: Child = sessionStorage.getItem('optionMenu') ? JSON.parse(sessionStorage.getItem('optionMenu')) : undefined;
        const favorites: Child[] = sessionStorage.getItem('userFavorites') ? JSON.parse(sessionStorage.getItem('userFavorites')) : [];
        let result = false;
        if (optionMenu && favorites) {
            for (const f of favorites) {
                if (f.ID === optionMenu.ID) {
                    result = true;
                }
            }
        }
        return result;
    }

}
